import React from 'react';
import {Avatar} from '@material-ui/core';
import './Message.css';

//<h4>{user.email}

function Message({timestamp,user, message, uid}) {
    return (
        <div className="message">
            <Avatar className="message__photo" src={user.photoUrl}/>
            <div className="message__info">
                <h4>{user.displayName}
                
                    <span className="message__timestamp">
                        {new Date(timestamp?.toDate()).toUTCString()}
                    </span>
                </h4>
                
                <p>{message}</p>
            </div>
        </div>
    )
}

export default Message
